(function () {
    'use strict';

    var PagePreviewControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-preview.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            scale: '<',
            cover: '<',
            pageIndex: '<',
            imgSize: '<',
            imgDpi: '<',
            isImageboxNot: '<',
            thumbnail: '<',
            isPageTrimbox: '<', //是否裁切出血线
            editorType: '<', //编辑器类型
            isOutline: '<'
        },

        controller: ['$scope', function ($scope) {
            var vm = this;
            function syncPageData() {
                if (vm.page) {
                    vm.pageData = angular.copy(vm.page);
                    if(vm.isPageTrimbox && !vm.pageData.scene && !vm.pageData.notTrimbox && vm.editorType != 'PICTURE_PRO_P'){
                        pageTrimbox(vm.pageData);
                    }
                } else {
                    vm.pageData = null;
                }
            }
            $scope.maskSize = function () {
                var maskSize = '100% 100%';
                if(vm.pageData && vm.pageData.mediabox1){
                    maskSize = (vm.pageData.mediabox1.width * vm.scale) + 'px ' + (vm.pageData.mediabox1.height * vm.scale) + 'px';
                }
                return maskSize;
            }

            vm.$onInit = function () {
                syncPageData();
                $scope.$watch(function () {
                    return vm.page;
                }, syncPageData, true);
            };
            //像素不足提醒
            var throttledResize = angular.throttle(function (item) {
                if(vm.imgSize && vm.imgDpi) {
                    return pxInsufficient(item, vm.imgSize, vm.imgDpi)
                }
            }, 1000);

            $scope.pxInsufficient = function (item) {
                if(vm.imgSize && vm.imgDpi){
                    return pxInsufficient(item, vm.imgSize, vm.imgDpi);
                }
            }
            //边框
            $scope.imageboxW = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.width
                        // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                    }
                } else {
                    return imagebox.geometry.width
                }
            }
            $scope.imageboxH = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.height
                        // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                    }
                } else {
                    return imagebox.geometry.height
                }
            }
            $scope.imageboxL = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.x
                        // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                    }
                } else {
                    return imagebox.geometry.x
                }
            }
            $scope.imageboxT = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.y
                        // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                    }
                } else {
                    return imagebox.geometry.y
                }
            }
            $scope.imageboxWEdge = function (imagebox, edge) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        if (edge == 'left') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                        }
                        if (edge == 'top') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                        }
                        if (edge == 'right') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                        }
                        if (edge == 'bottom') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                        }
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.dropShadow = function(imagebox,ratio){
                if (imagebox.shadow == null) {
                    imagebox.shadow={
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    }
                }
                var width = $scope.imageboxW(imagebox) * ratio;
                var height =$scope.imageboxH(imagebox) * ratio;
                return dropShadow(imagebox,width,height)
            }
            // 大图判断
            $scope.isLarge = function(imageInfo){
                if(!imageInfo)return
                return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
            }
            $scope.goldFoil = function(color){
                if(color){
                    return goldFoil(color)
                }
            }
            $scope.transitionPx = transitionPx;
            $scope.pageStyle = function(){
                if(vm.pageData && vm.pageData.mediabox){
                    var _style= {
                        'position': 'absolute',
                        'width': vm.pageData.mediabox.width * vm.scale,
                        'height': vm.pageData.mediabox.height * vm.scale,
                        'left': vm.pageData.scene && !vm.cover ? vm.pageData.scene.imagebox.geometry.x * vm.scale : vm.pageData.mediabox.x * vm.scale,
                        'top': vm.pageData.scene && !vm.cover ? vm.pageData.scene.imagebox.geometry.y * vm.scale : vm.pageData.mediabox.y * vm.scale,
                        'background': vm.pageData.background && vm.pageData.background.color&&vm.pageData.background.type == 'Color' ? vm.pageData.background.color : '',
                    }
                    if(vm.editorType == 'PICTURE_PRO_P'){
                        // '-webkit-mask-image': !vm.pageData.outline ? 'unset' : 'url(' + vm.pageData.outline.mask.resource.identifier + ')',
                        // '-webkit-mask-size': maskSize(),
                        // '-webkit-mask-position-x': vm.pageData.mediabox1 ? -vm.pageData.trimbox.x * vm.scale + 'px' : 'unset',
                        // '-webkit-mask-position-y': vm.pageData.mediabox1 ? -vm.pageData.trimbox.y * vm.scale + 'px' : 'unset',
                        if(vm.pageData.outline){
                            if(vm.pageData.outline.mask && vm.pageData.outline.mask.resource && vm.pageData.outline.mask.resource.identifier){
                                _style['-webkit-mask-image']= 'url(' + vm.pageData.outline.mask.resource.identifier + ')';
                                _style['-webkit-mask-size'] = transitionPx(vm.pageData.outline.geometry.width) * vm.scale + 'px ' + transitionPx(vm.pageData.outline.geometry.height) * vm.scale + 'px';
                                _style['-webkit-mask-position-x']= transitionPx(vm.pageData.outline.geometry.x) * vm.scale + 'px';
                                _style['-webkit-mask-position-y']= transitionPx(vm.pageData.outline.geometry.y) * vm.scale + 'px';
                            }
                        }else{
                            if(!vm.isOutline){
                                _style['-webkit-mask-image'] = 'linear-gradient(black, black)';
                                _style['-webkit-mask-size']= (vm.pageData.trimbox.width*vm.scale) + 'px ' + (vm.pageData.trimbox.height*vm.scale) + 'px';
                                _style['-webkit-mask-repeat']= 'no-repeat';
                                _style['-webkit-mask-position']= (vm.pageData.trimbox.x*vm.scale) + 'px ' + (vm.pageData.trimbox.y*vm.scale) + 'px'; // 默认 0 0，可根据需要给 x/y 定位
                            }

                        }
                    }
                    return _style
                }
            }
        }]
    };
    angular.module('editorApp')
    	.component('pagePreview', PagePreviewControl);

})();
